import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PopupLayout from "../../components/templetes/popupLayout";
import { StyledButton } from "../../components/atoms/button";
import { ValidationInput } from "../../components/atoms/validation/ValidationInput";
import { StyledButtonArea } from "../../components/molecules/buttonArea";
import { useSelector } from "react-redux";

const ForgotUserIDPopup = ({ findUserID, hasUserName, closePopup }) => {
  const { t } = useTranslation();
  const { userIds } = useSelector((store) => store.auth.forgotPopup);
  const [validate, setValidate] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [page, setPage] = useState(0);

  const onSubmit = () => {
    setValidate(true);
    if(hasUserName){
      if (name === "" || email === "") return;
    }else{      
      if (email === "") return;
    }
    findUserID(
      {
        username: name,
        email: email,
      },
      () => {
        setPage(1);
      }
    );
  };

  return (
    <>
      <PopupLayout
        theme="primary"
        data-size="lg"
        title={t("findId.title")}
        closePopup={closePopup}
        button={
          <StyledButtonArea>
            {page === 0 && (
              <StyledButton
                type="text"
                data-bg="primary"
                size="md"
                onClick={onSubmit}
              >
                {t("findId.submit")}
              </StyledButton>
            )}
          </StyledButtonArea>
        }
      >
        {page === 0 && (
          <div style={{ paddingLeft: "3%", paddingRight: "3%" }}>
            {hasUserName&&(<ValidationInput
              label={t("findId.name")}
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              showValidate={validate}
              invalidMsg={t("findId.nameRequired")}
            />)}
            <ValidationInput
              label={t("findId.email")}
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              showValidate={validate}
              invalidMsg={t("findId.emailRequired")}
            />
          </div>
        )}
        {page === 1 && (
          <div
            style={{
              paddingLeft: "3%",
              paddingRight: "3%",
              marginTop: "3%",
              minHeight: "20px",
              textAlign: "center",
            }}
          >
            <p>{t("findId.result")}</p>
            {userIds.map((userId, index) => (
              <span key={index} style={{ color: "blue", display: "block" }}>
                {userId}
              </span>
            ))}
          </div>
        )}
      </PopupLayout>
    </>
  );
};

export default ForgotUserIDPopup;
